import { connect } from 'react-redux';
import PressureSensorInstallForm from '../../components/PressureSensor/PressureSensorInstallForm';
import * as actionsSensors from '../../actions/SensorsActions';
import * as actionsInstall from '../../actions/InstallActions';
import { setMapDrawMode } from '../../actions/setters';

const mapStateToProps = (state, ownProps) => {
  const installState = state.install;
  const isWorking = installState.isWorking;
  const position = installState.newInstallItem?.position || null;
  const sopId = installState.newInstallItem?.sopId || null;
  const user = state.leaksList.user;
  const selectedProject = state.leaksList.selectedProject;
  const projectsIndexMap = state.leaksList.projectsList.projectIndexMap;
  const projectData = state.leaksList.projectsList.items[projectsIndexMap[selectedProject]];

  // Get logger types from server enums
  const loggerTypes = state.leaksList.optionList.options.pressure_loggers_types || [];

  // Get logger manufacturers from server enums (if needed)
  const loggerManufacturers = state.leaksList.optionList.options.pressure_loggers_manufacturers || [];

  return {
    user,
    position,
    sopId,
    isWorking,
    loggerTypes,
    loggerManufacturers,
    customerId: projectData?.CustomerID,
    selectedProject,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: (values, dispatch, props) => {
      const { position, sopId, selectedProject, customerId } = props;

      if (!position || position.length !== 2) {
        if (ownProps.notify) {
          ownProps.notify('Please select a position on the map', 'error');
        }
        return;
      }

      if (!values.deviceId) {
        if (ownProps.notify) {
          ownProps.notify('Missing Device ID', 'error');
        }
        return;
      }

      if (!values.loggerType) {
        if (ownProps.notify) {
          ownProps.notify('Please select a logger type', 'error');
        }
        return;
      }

      // If there's an existing SOP at this location, use its ID instead of creating a new one
      const data = {
        sop: sopId ? {
          id: sopId
        } : {
          position: {
            lat: position[1], // position is [lng, lat]
            lng: position[0],
          },
        },
        device: {
          customerId: customerId,
          deviceId: values.deviceId,
          loggerType: parseInt(values.loggerType),
        },
      };

      dispatch(actionsSensors.installPressureSensor(
        selectedProject,
        data,
        (data) => {
          if (data != null && ownProps.notify) {
            ownProps.notify(data.message, data.level);
          }
        }
      ));

      // Close the form and exit draw mode
      dispatch(actionsInstall.changeContext('PressureSensors'));
      dispatch(setMapDrawMode(false));
    },
    onCancel: () => {
      dispatch(actionsInstall.changeContext('PressureSensors'));
      dispatch(setMapDrawMode(false));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PressureSensorInstallForm);
